// Mapa central de departamentos -> caixa de e-mail de destino.
// Os formulários enviam apenas a `key` no payload; o backend é quem
// encaminha a mensagem para a `mailbox` correspondente (evita expor
// o endereço como campo livre, o que abriria relay para qualquer e-mail).
// Ajuste os endereços quando as caixas oficiais forem definidas.
export const CONTACT_DEPARTMENTS = [
  { key: 'suporte', label: 'Suporte', mailbox: 'suporte@joviplanet.com' },
  { key: 'comercial', label: 'Comercial', mailbox: 'comercial@joviplanet.com' },
  { key: 'financeiro', label: 'Financeiro', mailbox: 'financeiro@joviplanet.com' },
];

export const DEFAULT_DEPARTMENT = 'suporte';

export const getDepartmentMailbox = (key) =>
  CONTACT_DEPARTMENTS.find((d) => d.key === key)?.mailbox || '';

// Label em PT para telas que não usam i18n; nas telas traduzidas prefira
// t(`contact.form.departments.${key}`)
export const getDepartmentLabel = (key) =>
  CONTACT_DEPARTMENTS.find((d) => d.key === key)?.label || key;
